import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class SalesTargetsService {
  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private httpClient: HttpClient, private errorHandler: ConfigErrorHandler) { }

  /**
   * Get sales targets
   * @returns Array
   */
  getSalesTargets(): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/crm/sales-targets`;

    return this.httpClient.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get sales reps
   * @returns Array
   */
  getSalesReps(): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/crm/get-sales-reps`;

    return this.httpClient.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Store sale target
   * @param formData
   * @returns array
   */
  store(sales_rep_id:string, target_units: any):Observable<any>{

    let apiURL:string=`${this.baseURL}/v1/crm/sales-targets`;

     const data = {
      sales_rep_id:sales_rep_id,
      target_units: target_units
    };

    return this.httpClient.post(apiURL,data, { headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get sale target for editing
   * @returns Array
   */
  edit(id:string){

    let apiURL:string=`${this.baseURL}/v1/crm/edit-sales-target/${id}`;

    return this.httpClient.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Update sale target
   * @param sales_rep_id
   * @param target_units
   * @param month
   * @returns array
   */
  update(sales_rep_id:string, target_units: any, month:string):Observable<any>{

    let apiURL:string=`${this.baseURL}/v1/crm/update-sales-target`;

    const data = {
      sales_rep_id:sales_rep_id,
      target_units: target_units,
      month:month,
    };

    return this.httpClient.put(apiURL,data, { headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Delete sale target
   * @param salesRepId
   * @returns array
   */
  delete(salesRepId: string|null):Observable<any>{

    let apiURL:string=`${this.baseURL}/v1/crm/delete-sales-target/${salesRepId}`;

    return this.httpClient.delete(apiURL, { headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }
}
